import React, { PureComponent } from 'react'
import cx from 'classnames'
import uniqueId from 'lodash/uniqueId'
import PropTypes from 'prop-types'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styles from './TextInput.scss'

export default class TextInput extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      id: uniqueId('textinput-'),
      focused: false
    }
  }

  onFocus = e => {
    this.setState({ focused: true })
    if (this.props.onFocus) {
      this.props.onFocus(e)
    }
  }

  onBlur = e => {
    this.setState({ focused: false })
    if (this.props.onBlur) {
      this.props.onBlur(e)
    }
  }

  noop = () => {}

  render() {
    const {
      value,
      label,
      placeholder,
      onChange,
      icon,
      name,
      type,
      min,
      max,
      className,
      inputClassName,
      inputRef,
      error,
      readonly,
      ...rest
    } = this.props
    const { id, focused } = this.state

    const classes = cx(styles.root, {
      [styles.hasIcon]: icon,
      [styles.readonly]: readonly,
      [className]: className
    })

    const inputClasses = cx('form-control', {
      [styles.input]: true,
      [inputClassName]: inputClassName,
      [styles.readonly]: readonly,
      [styles.error]: error
    })

    const iconStyle = cx(styles.icon, {
      [styles.iconFocused]: focused
    })

    return (
      <div className={styles.root}>
        {label && (
          <label htmlFor={id} className={classes}>
            {label}
          </label>
        )}

        <input
          id={id}
          name={name}
          className={inputClasses}
          type={type ? type : 'text'}
          min={type === 'number' && min ? min : null}
          max={type === 'number' && max ? max : null}
          value={value}
          placeholder={placeholder}
          ref={inputRef}
          onChange={readonly ? this.noop : onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          readOnly={readonly}
          {...rest}
        />

        {icon && (
          <div className={iconStyle}>
            <FontAwesomeIcon icon={['fal', icon]}/>
          </div>
        )}
      </div>
    )
  }
}

TextInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
}
